
import { supabase } from "@/integrations/supabase/client";
import { QueryResult } from "../types";

/**
 * Queries related to contract expirations
 */
export const expirationQueries = {
  // Get upcoming expirations for table widget
  getUpcomingExpirations: async (year?: number): Promise<QueryResult> => {
    try {
      const currentYear = year || new Date().getFullYear();
      const startOfYear = new Date(currentYear, 0, 1).toISOString();
      const endOfYear = new Date(currentYear, 11, 31, 23, 59, 59).toISOString();
      
      const today = new Date();
      const ninetyDaysFromNow = new Date();
      ninetyDaysFromNow.setDate(today.getDate() + 90);
      
      // Format dates for Supabase query
      const todayStr = today.toISOString().split('T')[0];
      const ninetyDaysFromNowStr = ninetyDaysFromNow.toISOString().split('T')[0];

      // Get contracts expiring in the next 90 days that were created in the selected year
      const { data: upcomingExpirations, error } = await supabase
        .from('contracts')
        .select('id, supplier_name, expiry_date')
        .gte('expiry_date', todayStr)
        .lte('expiry_date', ninetyDaysFromNowStr)
        .gte('created_at', startOfYear)
        .lte('created_at', endOfYear)
        .order('expiry_date', { ascending: true });
      
      if (error) throw error;
      
      return {
        data: { upcomingExpirations },
        error: null
      };
    } catch (error) {
      console.error("Error fetching upcoming expirations:", error);
      return {
        data: { upcomingExpirations: [] },
        error
      };
    }
  }
};
